import type { EventRecordingStatus } from 'models';
import { Card, VideoLineIcon } from 'ui';
import { VideoRecording } from './video-recording';

type P = {
  src?: string;
  status?: EventRecordingStatus;
};

const EventDetailVideoRecording = ({ src, status }: P) => {
  if (!status || status === 'not_available') {
    return null;
  }

  return (
    <Card title={<Card.Title icon={<VideoLineIcon />}>Video recording</Card.Title>}>
      <VideoRecording src={src} status={status} />
    </Card>
  );
};

export default EventDetailVideoRecording;
